import React from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const PrivacyInJapan = () => (
  <div className="legal">
    <Head>
      <title>プライバシーポリシー | オンライン英会話のリンガルボックス</title>
    </Head>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
      <div className="mt-12 mb-24 text-wrap">
        <h1>プライバシーポリシー</h1>
        <p className="mb-8">最終更新日: 2013年2月14日</p>
        <p>
          LingualBox,
          Inc.が運営しております、オンライン英会話サービス「LingualBox」では、
          個人情報の保護に厳重な注意を払っております。
          以下が、弊社の個人情報の保護に対する考え方です。
        </p>
        <h3 className="mb-4 mt-8">個人情報の収集について</h3>
        <p>
          お客様に無断で、または不公正な方法でお客様の個人情報を収集することはございません。
        </p>
        <h3 className="mb-4 mt-8">個人情報の利用について</h3>
        <p>
          お客様に無断で、または不公正な方法でお客様の個人情報を収集することはございません。
          登録されたメールアドレスに、業務連絡や役立つ情報をお送りすることがあります。
          ご不要の場合はメール内からご自身で配信停止処理をしていただくことができます。
        </p>
        <h3 className="mb-4 mt-8">個人情報の管理について</h3>
        <p>
          お客様からご提供いただきました情報は慎重に管理し、個人情報への不正アクセス、個人情報の紛失、
          破壊、改ざんおよび漏えい等を防止するために、必要かつ適切な対策を実施いたします。
        </p>
        <h3 className="mb-4 mt-8">個人情報の開示について</h3>
        <p>
          お客様からご提供いただきました情報は、当社の管理するデータベースに個人情報として登録され、
          当社は登録された情報を個人情報として管理しますが、次のような場合には、特定の個人情報を
          第三者に提供・開示する場合があります。
        </p>
        <p>1.ユーザーの同意が得られた場合</p>
        <p>2.法令などにより公的機関より開示が求められた場合</p>
        <p>3.個人の識別ができない状態で提供する場合</p>
        <h3 className="mb-4 mt-8">講師との個人的な接触</h3>
        <p>
          ユーザーが当社のサービスにおける講師とオンライン、オフラインを問わず接触することを禁じます。
          講師との個人的な接触が原因となってユーザーの個人情報が流出した場合は、当社は一切の責任を負いません。
        </p>
        <h3 className="mb-4 mt-8">個人情報に関するお問い合わせ先</h3>
        <p>
          お客様ご自身の個人情報の照会・修正・削除の希望、その他個人情報に関するお問い合わせは、ご本人を確認させていただいた上で、適切に対応させていただきます。
        </p>
        <p>
          プライバシーポリシーに関するご質問は、support@lingualbox.com
          までお問い合わせください。
        </p>
      </div>
    </div>
  </div>
);

export const getStaticProps = async ({ locale = 'ja' }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'terms'])),
  },
});

export default PrivacyInJapan;
